<template lang="pug">
  modal-vue(:visible.sync="modalVisible" :content_loaded="true")
    template(v-slot:header)
      | {{ title }}
    template(v-slot:body)
      forms-autocomplete-tree-selector-vue(
        v-if="component == 'forms-autocomplete-tree-selector-vue'"
        v-model="selected" :nodes="data"
      )
      forms-date-selector-vue(
        v-if="component == 'forms-date-selector-vue'"
        :selected.sync="selected"
      )
    template(v-slot:footer)
      button.confirm_button.btn.btn-primary(type="button" @click="confirm")
        | {{ t('aceptar') }}
      button.cancel_button.btn.btn-secondary(type="button" @click="cancel")
        | {{ t('cerrar') }}
</template>

<script>
import mixins from 'common/mixins'

export default {
  props: {
    data: { type: Array, default: () => []},
    inputSelected: { type: Array, default: () => [] },
    component: { type: String, default: '' },
    title: { type: String, default: '' }
  },
  mixins: [mixins.translate],
  components: {
    'modal-vue': () => import(/* webpackChunkName: "[request]" */ 'components/Modal'),
    'forms-autocomplete-tree-selector-vue': () => import(/* webpackChunkName: "[request]" */ 'components/forms/AutocompleteTreeSelector'),
    'forms-date-selector-vue': () => import(/* webpackChunkName: "[request]" */ 'components/forms/DateSelector')
  },
  data() {
    return {
      selected: this.inputSelected,
      confirmed: this.inputSelected,
      modalVisible: false
    }
  },
  methods: {
    confirm() {
      this.confirmed = this.selected
      this.hideModal()
      this.$emit('confirm', this.confirmed)
    },
    cancel() {
      this.selected = this.confirmed
      this.hideModal()
      this.$emit('cancel')
    },
    showModal() {
      this.modalVisible = true
    },
    hideModal() {
      this.modalVisible = false
    },
    clear() {
      this.confirmed = []
      this.selected = []
    }
  },
  watch: {
    inputSelected(newValue) {
      this.selected = newValue
      this.confirmed = newValue
    }
  }
}
</script>
